import React from 'react';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import { formSpacingFactor } from 'globals/units';

export const FsFormGridItem = withStyles(() => ({}))((props: BoxProps) => (
  <Box
    display="flex"
    marginLeft={formSpacingFactor}
    marginRight={formSpacingFactor}
    flexGrow={1}
    flexBasis={0}
    {...props}
  />
));

export default FsFormGridItem;
